import { Dialog } from "@components";
import { productTypes } from "model/Product";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

interface TestDetailsDialogProps {
  open: boolean;
  onClose: (value: boolean) => void;
  device?: string;
  version?: string;
}

export default function TestDetailsDialog({
  open,
  onClose,
  device,
  version,
}: TestDetailsDialogProps) {
  const { t } = useTranslation();

  const deviceType = useMemo(() => {
    const devicePreCode = device?.split("-")[0];
    return devicePreCode && devicePreCode in productTypes
      ? productTypes[devicePreCode as keyof typeof productTypes]
      : "";
  }, [device]);

  return (
    <Dialog
      title={t("ResultList.testDetails")}
      open={open}
      onConfirm={onClose}
      confirmLabel={t("ResultList.close")}
      onCancel={onClose}
    >
      {device && (
        <>
          <h4>
            {t("ResultList.deviceId")} : {device}
          </h4>
          {deviceType && <h4>{deviceType}</h4>}
        </>
      )}
      {version && (
        <h4>
          {t("ResultList.version")} : {version}
        </h4>
      )}
    </Dialog>
  );
}
